import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "@/services/auth";
import { AequiaMark, Button, ErrorBanner, Input } from "@/components/ui";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "No se pudo solicitar el restablecimiento");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-bg grid place-items-center p-6">
      <form onSubmit={submit} className="w-full max-w-[420px] rounded-xl border border-border bg-surface p-7 shadow-subtle">
        <AequiaMark size={72} className="mb-6" />
        <div className="text-[11px] uppercase tracking-eyebrow text-muted font-semibold mb-2">
          Recuperación de cuenta
        </div>
        <h1 className="font-serif text-3xl font-medium tracking-tightish mb-2">Restablecer contraseña</h1>
        <p className="text-sm text-muted mb-6">
          Ingresa tu correo corporativo. Si existe una cuenta asociada, enviaremos las instrucciones de recuperación.
        </p>
        {sent ? (
          <div className="rounded-lg border border-success/30 bg-success-soft p-4 text-sm text-success">
            Solicitud recibida. Revisa tu correo y sigue el enlace de recuperación.
          </div>
        ) : (
          <>
            <Input
              label="Correo corporativo"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="usuario@empresa.com"
              autoComplete="email"
              required
            />
            {error && <div className="mb-3"><ErrorBanner message={error} /></div>}
            <Button type="submit" variant="brand" size="lg" full loading={loading}>
              Enviar instrucciones
            </Button>
          </>
        )}
        <Link to="/login" className="block text-center text-xs text-muted hover:text-text mt-5">
          Volver al inicio de sesión
        </Link>
      </form>
    </div>
  );
}
